// Types ComponentsStructureMap and WidgetsAPIMap are used as placeholders.
// Wix CLI will override them inside user's folder with types that based on structure of user's components.
import type { ComponentsStructureMap, WidgetsAPIMap } from '@wix/blocks/types';
import type { $Widget, $W } from './internal-types';

type WidgetController<
  P extends Record<string, any>,
  T extends Record<string, any>,
  E extends Record<string, any>,
  Q extends Record<string, any>,
> = ($w: $W<P>, $widget: $Widget<T, E>) => Q;

type DefineWidgetFn = <
  P extends keyof ComponentsStructureMap,
  L extends WidgetController<
    ComponentsStructureMap[P],
    WidgetsAPIMap[P]['props'],
    WidgetsAPIMap[P]['events'],
    WidgetsAPIMap[P]['functions']
  >,
>(
  id: P,
  fn: L,
) => L;

export const defineWidget: DefineWidgetFn = (_id, fn) => fn;
